import { colorCoreBlack900Base, colorCoreWhite1000 } from '@yme/tokens/colors';
export const STATUS_INIT = 'STATUS_INIT';
export const STATUS_RELOAD = 'STATUS_RELOAD';
export const STATUS_CHANGE = 'STATUS_CHANGE';
export const STATUS_COLOR_CHANGE = 'STATUS_COLOR_CHANGE';
export const DEFAULT_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON = {
    color: colorCoreBlack900Base,
};
export const ACTIVE_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON = {
    color: colorCoreWhite1000,
};
